// extracted by mini-css-extract-plugin
export default {"main":"_5a1b5c8ccf ce0023905d","xmark":"b1d9e3364e","fl_img":"cf83968b2e _00c839552f"};